
import { IIconsProps } from "components/Icons/icons.model"

const CustomTableDollar = (props: IIconsProps) => {
    return (
        <i id={props.id} className="fa-solid fa-file-invoice-dollar" style={{ fontSize: props.fontSize, color: props.color, ...props.style }} />
    )
}

export default CustomTableDollar;